// extracted by mini-css-extract-plugin
module.exports = {"gradient":"GradientBanner-module__gradient___if9kR"};